import React from "react";
import PunchDetails from "./PunchDetails"; // ADD-ON: biometric punch times

const MarkAttendanceStyle = (params) => {
    if (params.formattedValue === "A") {
        return (
            <div style={{ color: "red", fontWeight: "bold" }}>
                {params.formattedValue}
            </div>
        );
    }
    if (params.formattedValue === "P" || params.formattedValue === "P(H)") {
        return (
            <div style={{ color: "green", fontWeight: "bold" }}>
                {params.formattedValue}
            </div>
        );
    }
    if (params.formattedValue === "WFH" || params.formattedValue === "WO") {
        return (
            <div style={{ color: "blue", fontWeight: "bold" }}>
                {params.formattedValue}
            </div>
        );
    }
};

// ---- BIOMETRIC PUNCH DETAILS ADD-ON ------------------------------------
// To switch the punch times off: delete this whole block, delete the
// PunchDetails import at the top, and un-comment the original export below.
// The MarkAttendanceStyle function above is not touched by any of this.
const MarkAttendanceStyleWithPunch = (params) => (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
        {/* The original cell. It returns nothing for statuses it does not know
            (HD, CO, NM, leave types...), so fall back to plain text, otherwise
            those days would show the punch times with no status above them. */}
        {MarkAttendanceStyle(params) || <div>{params.formattedValue}</div>}
        <PunchDetails params={params} />
    </div>
);

export default MarkAttendanceStyleWithPunch;
// ---- END BIOMETRIC PUNCH DETAILS ADD-ON --------------------------------

// export default MarkAttendanceStyle;
